import { debounce } from '@opten/reactive/debounce';

export class GlobalVarsComponent {
	constructor(private element: HTMLElement = document.documentElement) {
		this.setGlobalVars();
		window.addEventListener(
			'resize',
			debounce(() => {
				this.setGlobalVars();
			}, 300)
		);
	}

	setGlobalVars() {
		this.element.style.setProperty(
			'--window-height',
			`${window.innerHeight * 0.01 * 100}px`
		);
	}
}
